import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { withT } from '../../../../lib/wrappers';

const scrollModalIntoView = () => {
  if (!window.parentIFrame) return;
  window.parentIFrame.scrollTo(0, 0);
};

const RestoreDefaultAnswers = ({ show, restoreDefaults, close, t, is_user_logged_in }) => (
  <Modal show={show} id="restore_default_answers_modal" onEntered={scrollModalIntoView}>
    <Modal.Header>
      <h4 className="modal-title">{t('Restore Default Answers')}</h4>
    </Modal.Header>
    <Modal.Body>
      {!is_user_logged_in &&
        <p>
          {t('For your convenience, we save your answers in your browser\'s storage. They are not saved on a server unless you sign up.')}
        </p>
      }
      {is_user_logged_in &&
        <p>
          {t('As a registered user, your answers are stored on a server so that you can update the calculator at your convience.')}
        </p>
      }
      <p>
        {t('If you would like to restore your answers to the calculator defaults, please confirm below.')}
      </p>
    </Modal.Body>
    <Modal.Footer>
      <button
        id="restore_defaults__confirm"
        type="button"
        className="btn btn-primary"
        onClick={() => restoreDefaults()}
      >{t('Erase my answers')}</button>
      <button
        id="restore_defaults__cancel"
        type="button"
        className="btn btn-default"
        onClick={close}
      >{t('Cancel')}</button>
    </Modal.Footer>
  </Modal>
);

RestoreDefaultAnswers.propTypes = {
  show: PropTypes.bool.isRequired,
  restoreDefaults: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  is_user_logged_in: PropTypes.bool.isRequired,
};

export default withT('modals')(RestoreDefaultAnswers);
